"use client";

import { useQuery } from "@tanstack/react-query";
import techficientService, {
  type TechficientAgencyDashboardResponse,
  type TechficientAgentDetailsResponse,
} from "@/app/_module/services/techficientService";

/**
 * Agency-wide Techficient dashboard rollup — feeds the Commissions tab on
 * /agency-dashboard. Backend recursively walks the agency tree, so a single
 * call returns the whole downline (or just one slice if a sub-agency owner
 * is asking).
 */
export const useTechficientAgencyDashboard = (
  agencyId: string | null | undefined,
  enabled = true,
) =>
  useQuery<TechficientAgencyDashboardResponse>({
    queryKey: ["techficient", "agency-dashboard", agencyId],
    queryFn: () => techficientService.getAgencyDashboard(agencyId as string),
    enabled: !!agencyId && enabled,
    staleTime: 60_000,
    gcTime: 5 * 60_000,
    retry: 1,
  });

/**
 * Single-agent Techficient profile — provisioning, contracts, cases,
 * commission. Lazy: only fires when the panel is mounted.
 */
export const useTechficientAgentDetails = (
  userId: string | null | undefined,
  enabled = true,
) =>
  useQuery<TechficientAgentDetailsResponse>({
    queryKey: ["techficient", "agent-details", userId],
    queryFn: () => techficientService.getAgentTechficientDetails(userId as string),
    enabled: !!userId && enabled,
    staleTime: 30_000,
    gcTime: 5 * 60_000,
    retry: 1,
  });
